import { GlobalInput, GlobalEquipment } from '../types';
import { catchAllSingle, checkCustomFields } from './filterDirtyUtils';

type IAnyDirty = GlobalInput['dirtyGlobalFields']['equipment'];
type GlobalEquipmentEntries = readonly [
  string,
  GlobalEquipment[keyof GlobalEquipment],
];
type IFilteredEntries = GlobalEquipmentEntries | readonly [string, undefined];
export function filterGlobalDirty(
  globalValues: GlobalEquipment,
  anyDirty: IAnyDirty | undefined,
): Partial<GlobalEquipment> {
  if (!anyDirty) return {};
  const filteredValues = Object.keys(globalValues).map<IFilteredEntries>(
    key => {
      const keyt = key as keyof GlobalEquipment;
      const valuesT = globalValues;
      // unit fields
      if (keyt !== 'tagsId' && keyt !== 'customFields') {
        return catchAllSingle(keyt, valuesT, anyDirty);
      }
      // Anything forcefully unit
      if (typeof anyDirty[keyt] === 'boolean') {
        return catchAllSingle(keyt, valuesT, anyDirty);
      }
      // tags
      if (keyt === 'tagsId') {
        const dirtytags = anyDirty[keyt];
        const value = valuesT[keyt];
        if (!dirtytags) return [keyt, undefined] as const;
        // If tags have changed, send all!
        if (Object.values(dirtytags).some(_value => _value.count)) {
          return [keyt, value] as const;
        }
        return [keyt, undefined] as const;
      }
      // customfields
      if (keyt === 'customFields') {
        return checkCustomFields(keyt, valuesT, anyDirty) as IFilteredEntries;
      }
      // should never happen
      return [keyt, valuesT[keyt]] as const;
    },
  );
  const withoutUndefined = filteredValues.filter(
    value => value[1] !== undefined,
  );
  const obj = Object.fromEntries(withoutUndefined);
  return obj;
}
